import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../../api';
import { backerKeys } from '../../../query-key-factory';
import { Backer } from '../../../types';

const useUpdateCauseBackerDirectorySettings = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const updateCauseBackerDirectorySettings = async ({
    causeId,
    backer,
  }: {
    causeId: string;
    backer: Pick<Backer, 'show_in_directory' | 'show_email' | 'show_phone'>;
  }) => {
    const { data } = await BackerApi.put<{ backer: Backer }>(
      `/consumer/backer/causes/${causeId}/directory_settings`,
      { cause_backer: backer }
    );
    return data.backer;
  };

  return useMutation({
    mutationFn: updateCauseBackerDirectorySettings,
    onSuccess: (_, variables) => {
      const { causeId } = variables;
      /* while we are hitting a consumer endpoint here, we are making an update to a cause backer and should invalidate the cause backer query
       so that the new values are reflected in the Directory Settings modal */
      return queryClient.invalidateQueries({ queryKey: backerKeys.causes.id(causeId).backer });
    },
  });
};

export { useUpdateCauseBackerDirectorySettings };
